/**
 * @generated SignedSource<<20265d704eb984f4b13dbd13b8761056>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatePageQuery$variables = {
  addressOrEnsName: string;
};
export type DelegatePageQuery$data = {
  readonly address: {
    readonly wrappedDelegate: {
      readonly delegate: {
        readonly " $fragmentSpreads": FragmentRefs<"PastVotesFragment">;
      } | null;
      readonly statement: {
        readonly statement: string;
        readonly " $fragmentSpreads": FragmentRefs<"ImpactfulProposalsFragment" | "TopIssuesFragment">;
      } | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"VoterPanelDelegateFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelQueryFragment">;
};
export type DelegatePageQuery = {
  response: DelegatePageQuery$data;
  variables: DelegatePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "addressOrEnsName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "addressOrEnsName",
    "variableName": "addressOrEnsName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statement",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "orderDirection",
  "value": "desc"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delegatedVotes",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalValue",
  "storageKey": null
},
v10 = [
  (v4/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Seed",
    "kind": "LinkedField",
    "name": "seed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessory",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "background",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "glasses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "head",
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ResolvedName",
  "kind": "LinkedField",
  "name": "resolvedName",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = [
  (v4/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegatePageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VoterPanelQueryFragment"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Address",
        "kind": "LinkedField",
        "name": "address",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WrappedDelegate",
            "kind": "LinkedField",
            "name": "wrappedDelegate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "delegate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PastVotesFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DelegateStatement",
                "kind": "LinkedField",
                "name": "statement",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ImpactfulProposalsFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TopIssuesFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VoterPanelDelegateFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegatePageQuery",
    "selections": [
      {
        "alias": "recentProposals",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 10
          },
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": "createdBlock"
          },
          (v3/*: any*/)
        ],
        "concreteType": "Proposal",
        "kind": "LinkedField",
        "name": "proposals",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": "proposals(first:10,orderBy:\"createdBlock\",orderDirection:\"desc\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Governance",
        "kind": "LinkedField",
        "name": "currentGovernance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "proposals",
            "storageKey": null
          },
          (v6/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OverallMetrics",
        "kind": "LinkedField",
        "name": "metrics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quorumVotesBPS",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Address",
        "kind": "LinkedField",
        "name": "address",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WrappedDelegate",
            "kind": "LinkedField",
            "name": "wrappedDelegate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "delegate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": "blockNumber"
                      },
                      (v3/*: any*/)
                    ],
                    "concreteType": "Vote",
                    "kind": "LinkedField",
                    "name": "votes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reason",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "supportDetailed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "votes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Proposal",
                        "kind": "LinkedField",
                        "name": "proposal",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "votes(orderBy:\"blockNumber\",orderDirection:\"desc\")"
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 60
                      }
                    ],
                    "concreteType": "Noun",
                    "kind": "LinkedField",
                    "name": "nounsRepresented",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": "nounsRepresented(first:60)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "delegatedVotesRaw",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "tokenHoldersRepresented",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenBalance",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Noun",
                        "kind": "LinkedField",
                        "name": "nouns",
                        "plural": true,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DelegateVotesSummary",
                    "kind": "LinkedField",
                    "name": "voteSummary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forVotes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "againstVotes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "abstainVotes",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Proposal",
                    "kind": "LinkedField",
                    "name": "proposals",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DelegateStatement",
                "kind": "LinkedField",
                "name": "statement",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Proposal",
                    "kind": "LinkedField",
                    "name": "mostValuableProposals",
                    "plural": true,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Proposal",
                    "kind": "LinkedField",
                    "name": "leastValuableProposals",
                    "plural": true,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TopIssue",
                    "kind": "LinkedField",
                    "name": "topIssues",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "twitter",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "discord",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de13a560ff4a196069d210f2b2f8a769",
    "id": null,
    "metadata": {},
    "name": "DelegatePageQuery",
    "operationKind": "query",
    "text": "query DelegatePageQuery(\n  $addressOrEnsName: String!\n) {\n  ...VoterPanelQueryFragment\n  address(addressOrEnsName: $addressOrEnsName) {\n    wrappedDelegate {\n      delegate {\n        ...PastVotesFragment\n        id\n      }\n      statement {\n        statement\n        ...ImpactfulProposalsFragment\n        ...TopIssuesFragment\n      }\n      id\n    }\n    ...VoterPanelDelegateFragment\n  }\n}\n\nfragment DelegateDialogFragment on WrappedDelegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n    }\n  }\n  delegate {\n    delegatedVotesRaw\n    nounsRepresented(first: 60) {\n      id\n      ...NounImageFragment\n    }\n    id\n  }\n}\n\nfragment ImpactfulProposalsFragment on DelegateStatement {\n  mostValuableProposals {\n    id\n    ...ImpactfulProposalsProposalFragment\n  }\n  leastValuableProposals {\n    id\n    ...ImpactfulProposalsProposalFragment\n  }\n}\n\nfragment ImpactfulProposalsProposalFragment on Proposal {\n  number\n  title\n  totalValue\n}\n\nfragment NounGridFragment on Delegate {\n  delegatedVotesRaw\n  nounsRepresented(first: 60) {\n    id\n    ...NounImageFragment\n  }\n}\n\nfragment NounImageFragment on Noun {\n  number\n  seed {\n    accessory\n    background\n    body\n    glasses\n    head\n    id\n  }\n}\n\nfragment NounResolvedLinkFragment on ResolvedName {\n  address\n  ...NounResolvedNameFragment\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment PastVotesFragment on Delegate {\n  votes(orderBy: blockNumber, orderDirection: desc) {\n    id\n    ...VoteDetailsFragment\n  }\n}\n\nfragment TopIssuesFragment on DelegateStatement {\n  topIssues {\n    type\n    value\n  }\n}\n\nfragment VoteDetailsFragment on Vote {\n  reason\n  supportDetailed\n  votes\n  createdAt\n  proposal {\n    number\n    title\n    totalValue\n    id\n  }\n}\n\nfragment VoterCardDelegateProfileImage on WrappedDelegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n  delegate {\n    nounsRepresented(first: 60) {\n      id\n    }\n    ...NounGridFragment\n    id\n  }\n}\n\nfragment VoterPanelActionsFragment on WrappedDelegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelDelegateButtonFragment\n}\n\nfragment VoterPanelDelegateButtonFragment on WrappedDelegate {\n  ...DelegateDialogFragment\n}\n\nfragment VoterPanelDelegateFragment on Address {\n  resolvedName {\n    ...VoterPanelNameSectionFragment\n  }\n  wrappedDelegate {\n    ...VoterCardDelegateProfileImage\n    ...VoterPanelActionsFragment\n    delegate {\n      id\n      delegatedVotes\n      ...VoterPanelDelegateFromListFragment\n      voteSummary {\n        forVotes\n        againstVotes\n        abstainVotes\n      }\n      votes(orderBy: blockNumber, orderDirection: desc) {\n        id\n        proposal {\n          id\n        }\n      }\n      proposals {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment VoterPanelDelegateFromListFragment on Delegate {\n  tokenHoldersRepresented {\n    id\n    tokenBalance\n    address {\n      resolvedName {\n        ...NounResolvedLinkFragment\n      }\n    }\n    nouns {\n      id\n      ...NounImageFragment\n    }\n  }\n}\n\nfragment VoterPanelNameSectionFragment on ResolvedName {\n  address\n  name\n}\n\nfragment VoterPanelQueryFragment on Query {\n  recentProposals: proposals(orderBy: createdBlock, orderDirection: desc, first: 10) {\n    id\n  }\n  currentGovernance {\n    proposals\n    delegatedVotes\n    id\n  }\n  metrics {\n    quorumVotesBPS\n  }\n}\n"
  }
};
})();

(node as any).hash = "91ee57428f671167e5c3b27e26626562";

export default node;
